<template>
  <div>
    <div :id="id" :style="{ height: height, width: width }" />
  </div>
</template>
<script>
import echarts from 'echarts'
export default {
  props: {
    option: {
      type: Object
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    option: {
      handler(newValue, oldValue) {
        this.initChart()
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      let theme = this.option.config.theme
        ? this.option.config.theme
        : ['#8F8CEF', '#FFCD27', '#37CE7A', '#F89D8B', '#8CB1EF']
      this.chart = echarts.init(document.getElementById(this.id))
      const OPTIONS = this.option
      const seriesData = (OPTIONS.data || []).map((item) => {
        return {
          data: item.data,
          name: item.name,
          type: 'line'
        }
      })
      this.chart.setOption({
        color: theme,
        title: {
          text: OPTIONS.title,
          x: 'left',
          left: '2%',
          textStyle: {
            fontSize: 14,
            lineHeight: 40
          }
        },
        legend: {
          show: OPTIONS.config.legendData,
          icon: 'circle',
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 13,
          top: 5,
          data: OPTIONS.config.legendData,
          textStyle: {
            fontSize: 12,
            color: '#999'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '7%',
          top: '15%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: OPTIONS.config.xData,
            //  axisLabel: {
            //   interval: 0,
            // },
            axisLine: {
              lineStyle: {
                color: '#999'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false,
              lineStyle: {}
            },
            nameTextStyle: {
              color: '#999'
            },
            splitArea: {
              show: false
            }
          }
        ],
        series: seriesData
      })
    }
  },
  created() {}
}
</script>
